import moment from 'moment'
import type {TotalShipmentsResponse} from './_types'

export type TimeRange = 'ytd' | 'mtd' | 'wtd'

export type OrganizationPeriod = TimeRange | 'custom'

export const TIME_RANGES: {id: TimeRange; label: string}[] = [
  {id: 'ytd', label: 'YTD'},
  {id: 'mtd', label: 'MTD'},
  {id: 'wtd', label: 'WTD'},
]

export const getRangeForPreset = (range: TimeRange) => {
  const end = moment().endOf('day')

  switch (range) {
    case 'mtd':
      return {start: moment().startOf('month'), end}
    case 'wtd':
      return {start: moment().startOf('week'), end}
    case 'ytd':
    default:
      return {start: moment().startOf('year'), end}
  }
}

export type ShipmentTrendBreakout = 'overall' | 'carrier' | 'service'

export const SHIPMENT_TREND_BREAKOUTS: ShipmentTrendBreakout[] = ['overall', 'carrier', 'service']

export const TREND_VIEW_LABEL_KEYS: Record<ShipmentTrendBreakout, string> = {
  overall: 'OVERALL',
  carrier: 'CARRIER',
  service: 'SERVICE',
}

export const OVERALL_SERIES_COLOR = '#14B8A6'

export const TREND_SERIES_COLORS = ['#0B6D65', '#14B8A6', '#15569C', '#B1C360', '#FAB80A']

export const TREND_DAILY_AXIS_MAX_DAYS = 60

export const EMPTY_ANALYTICS_METRIC: TotalShipmentsResponse = {
  total: 0,
  delta: 0,
  period: '',
  carrier_breakout: [],
}

export const COMPARISON_OPERATORS = [
  'gt',
  'lt',
  'gte',
  'lte',
  'between',
  'not_between',
  'neq',
] as const

export const ORGANIZATION_ACCOUNTS_FILTER_QUERY_KEYS = [
  'create_date_from',
  'create_date_to',
  'last_shipment_date_from',
  'last_shipment_date_to',
  'spend_operator',
  'spend_value',
  'spend_value_to',
  'volume_operator',
  'volume_value',
  'volume_value_to',
] as const
